import {
	Button,
	FloatLabelInput,
	Loading,
	Modal,
	Select,
	Table,
} from '@buildbox/components'
import React from 'react'
import ModalDelete from 'shared/components/ModalDelete'
import PageTitle from 'shared/components/PageTitle'
import Switch from 'shared/components/Switch'
import {
	primaryButtonDelete,
	primaryButtonStyles,
	primaryInputStyles,
	primarySelectStyles,
	smallPrimaryButtonStyles,
	tableStyle,
	theme,
} from 'shared/styles/theme'
import { unitOpenHours } from 'shared/util/Consts'
import {
	Container,
	Line,
	ModalContent,
	OfferContainer,
	OfferModalContainer,
	PageHeader,
	TableContent,
	TextForm,
} from './styles'
import { EOpeningHourType, IViewProps } from './types'
import { formatPhone } from 'shared/util/mask'

function ListRetail(props: IViewProps): JSX.Element {
	const {
		tableColumns,
		tableRows,
		loading,
		showModal,
		changeModalState,
		handleChange,
		selectedRetail,
		create,
		edit,
		deleteModal,
		changeDeleteModalState,
		deleteRetails,
		isFormValid,
		handleSelectChange,
		returnSelectedOptions,
		handleOfferChange,
		editOfferModal,
		onCloseModalOffer,
		editOffers,
		onCloseModal,
		externalIDloading,
		setMissingExternalApiReferenceToast,
	} = props

	return (
		<>
			<Container>
				<PageHeader>
					<PageTitle>{'Lojas'}</PageTitle>
					<Button {...primaryButtonStyles} onClick={() => changeModalState()}>
						{'Nova'}
					</Button>
				</PageHeader>
				<TableContent>
					{loading ? (
						<Loading type='Digital' primaryColor='#354D9E' />
					) : (
						<div className='table-container'>
							<Table {...tableStyle} columns={tableColumns} data={tableRows} />
						</div>
					)}
				</TableContent>
				<Modal
					isActive={showModal}
					onClose={() => onCloseModal()}
					title={selectedRetail._id ? 'Atualizar Loja' : 'Nova Loja'}
				>
					<ModalContent>
						{externalIDloading ? (
							<div className='external-api-reference-load'>
								<Loading
									type='Spinner'
									primaryColor={theme.colors.blue}
									size={30}
								/>
							</div>
						) : null}
						<div className='input-container-wrapper'>
							<div className='input-container'>
								<FloatLabelInput
									{...primaryInputStyles}
									label='ID externo da loja em oferta (opcional)'
									round
									id='externalApiReference'
									onChange={(event) => handleChange({ event })}
									value={selectedRetail.externalApiReference}
								/>
							</div>

							<div className='input-container'>
								<FloatLabelInput
									{...primaryInputStyles}
									label='Nome da loja'
									round
									id='name'
									onChange={(event) => handleChange({ event })}
									value={selectedRetail.name}
								/>
							</div>
							<div className='double-input-container'>
								<div className='input-container'>
									<FloatLabelInput
										{...primaryInputStyles}
										label='Endereço'
										round
										id='street'
										onChange={(event) =>
											handleChange({ event, isAddress: true })
										}
										value={selectedRetail.address.street}
									/>
								</div>
								<div className='input-container input-container-number'>
									<FloatLabelInput
										{...primaryInputStyles}
										label='Número'
										round
										id='number'
										onChange={(event) =>
											handleChange({ event, isAddress: true })
										}
										value={selectedRetail.address.number}
									/>
								</div>
							</div>
							<div className='double-input-container'>
								<div className='input-container'>
									<FloatLabelInput
										{...primaryInputStyles}
										label='Cidade'
										round
										id='city'
										onChange={(event) =>
											handleChange({ event, isAddress: true })
										}
										value={selectedRetail.address.city}
									/>
								</div>
								<div className='input-container'>
									<FloatLabelInput
										{...primaryInputStyles}
										label='Estado'
										round
										id='state'
										onChange={(event) =>
											handleChange({ event, isAddress: true })
										}
										value={selectedRetail.address.state}
									/>
								</div>
							</div>
							<div className='input-container'>
								<FloatLabelInput
									{...primaryInputStyles}
									label='Telefone'
									round
									id='phone'
									onChange={(event) => handleChange({ event })}
									value={formatPhone(selectedRetail.phone)}
								/>
							</div>
							<TextForm>Horário de funcionamento - Seg a Sáb</TextForm>
							<div className='double-input-container'>
								<div className='input-container'>
									<Select
										{...primarySelectStyles}
										round
										options={unitOpenHours}
										placeholder='--:--'
										onChange={(selectOption: any) => {
											handleSelectChange(
												EOpeningHourType.BUSINESS_DAY,
												'start',
												selectOption?.value || '',
											)
										}}
										value={returnSelectedOptions(
											selectedRetail.openingHours.bussinessDay.start,
										)}
									/>
								</div>
								<div className='input-container'>
									<Select
										{...primarySelectStyles}
										round
										placeholder='--:--'
										options={unitOpenHours}
										onChange={(selectOption: any) => {
											handleSelectChange(
												EOpeningHourType.BUSINESS_DAY,
												'end',
												selectOption?.value || '',
											)
										}}
										value={returnSelectedOptions(
											selectedRetail.openingHours.bussinessDay.end,
										)}
									/>
								</div>
							</div>
							<TextForm>Horário de funcionamento - Dom e feriados</TextForm>
							<div className='double-input-container'>
								<div className='input-container'>
									<Select
										{...primarySelectStyles}
										round
										placeholder='--:--'
										onChange={(selectOption: any) => {
											handleSelectChange(
												EOpeningHourType.HOLYDAY,
												'start',
												selectOption?.value || '',
											)
										}}
										options={unitOpenHours}
										value={returnSelectedOptions(
											selectedRetail.openingHours.holyDay.start,
										)}
									/>
								</div>
								<div className='input-container'>
									<Select
										{...primarySelectStyles}
										round
										options={unitOpenHours}
										placeholder='--:--'
										onChange={(selectOption: any) => {
											handleSelectChange(
												EOpeningHourType.HOLYDAY,
												'end',
												selectOption?.value || '',
											)
										}}
										value={returnSelectedOptions(
											selectedRetail.openingHours.holyDay.end,
										)}
									/>
								</div>
							</div>
							<div className='input-container'>
								<FloatLabelInput
									{...primaryInputStyles}
									label='Ocupação Máxima'
									round
									id='maxOccupancy'
									onChange={(event) => handleChange({ event })}
									value={selectedRetail.maxOccupancy}
									type='number'
								/>
							</div>
						</div>
						<Line />
						<OfferContainer>
							<div className='offers-texts'>
								<h3 className='offer-title'>Ofertas cadastradas</h3>
								<h3 className='offer-subTitle'>
									Exibir ofertas para os clientes da loja?
								</h3>
							</div>
							{selectedRetail.externalApiReference ? (
								<Switch
									label=''
									isChecked={selectedRetail.isOffersActive}
									checked={selectedRetail.isOffersActive}
									onChange={(event) => {
										handleOfferChange(event)
									}}
								/>
							) : (
								<Switch
									label=''
									isChecked={false}
									checked={false}
									onChange={setMissingExternalApiReferenceToast}
								/>
							)}
						</OfferContainer>
						<div className='button-container'>
							<Button {...primaryButtonDelete} onClick={onCloseModal}>
								Cancelar
							</Button>
							<Button
								disabled={!isFormValid}
								{...primaryButtonStyles}
								onClick={selectedRetail._id ? edit : create}
							>
								{selectedRetail._id ? 'Atualizar' : 'Cadastrar'}
							</Button>
						</div>
					</ModalContent>
				</Modal>
				<ModalDelete
					isActive={deleteModal}
					onClose={() => changeDeleteModalState()}
					title='Excluir Loja'
					message={`Você optou por Excluir a loja ${selectedRetail.name}, esta ação não poderá ser desfeita!`}
					onConfirm={deleteRetails}
					textButton='Excluir Loja'
				/>
				<Modal
					isActive={editOfferModal}
					title='Tem certeza disso?'
					onClose={onCloseModalOffer}
				>
					<ModalContent>
						<OfferModalContainer>
							<p>
								{selectedRetail.isOffersActive
									? `Os clientes da loja ${selectedRetail.name}, passarão a não ver a
								oferta cadastrada.`
									: `Os clientes da loja ${selectedRetail.name}, passarão a ver
								a oferta cadastrada.`}
							</p>
							<div className='buttons'>
								<Button {...primaryButtonDelete} onClick={onCloseModalOffer}>
									Cancelar
								</Button>
								<Button {...smallPrimaryButtonStyles} onClick={editOffers}>
									{selectedRetail.isOffersActive
										? 'Ocultar ofertas'
										: 'Exibir ofertas'}
								</Button>
							</div>
						</OfferModalContainer>
					</ModalContent>
				</Modal>
			</Container>
		</>
	)
}

export default ListRetail
